import { BaseEntity } from '@base-entities';
import { BaseTransformer } from '@base-transformers';

export class CommonTransformer<PayloadEntity extends BaseEntity = BaseEntity> extends BaseTransformer<PayloadEntity> {}
